import type { ListingDoc } from '@bb/domain/dist/schemas';
import type { EnhancedAppointment } from '@bb/domain/dist/types';
import axios from 'axios';

export type AppointmentData = {
  listing: ListingDoc;
  appointment: EnhancedAppointment;
};

export type GetAppointmentsResponse = {
  maxCount: number;
  count: number;
  data: AppointmentData[];
};

const getAppointments = async ({
  page,
  search,
  mlsTypes,
  limit,
}: {
  page: number;
  search?: string;
  mlsTypes?: string[];
  limit?: number;
}) => {
  const { data } = await axios.get<GetAppointmentsResponse>(
    `/answering/appointments/${page}`,
    {
      params: {
        search: search || undefined,
        mlsTypes: mlsTypes?.length ? mlsTypes : undefined,
        limit: limit || undefined,
      },
      paramsSerializer: params => {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
          if (value === undefined) return;
          if (Array.isArray(value)) {
            value.forEach(v => searchParams.append(key, v));
          } else {
            searchParams.append(key, String(value));
          }
        });
        return searchParams.toString();
      },
    },
  );
  return data;
};

export default getAppointments;
